<div class="c4g-paginator" [class.disabled]="disabled">
  <div class="c4g-paginator-container">
    <div class="c4g-paginator-range-label">
      {{ getRangeLabel(pageIndex, pageSize, length) }}
    </div>

    <div class="c4g-paginator-controls">
      <button
        class="c4g-paginator-button"
        [disabled]="disabled || pageIndex === 0"
        (click)="onPageChange({ pageIndex: 0, pageSize, length })"
        *ngIf="showFirstLastButtons"
        [attr.aria-label]="getFirstPageLabel()"
      >
        <span class="c4g-paginator-icon">first_page</span>
      </button>

      <button
        class="c4g-paginator-button"
        [disabled]="disabled || pageIndex === 0"
        (click)="onPageChange({ pageIndex: pageIndex - 1, pageSize, length })"
        [attr.aria-label]="getPreviousPageLabel()"
      >
        <span class="c4g-paginator-icon">chevron_left</span>
      </button>

      <!-- Go to page select replaces page number bubbles -->
      <div class="c4g-paginator-go-to-page" *ngIf="getMaxPage() > 0">
        <label class="c4g-paginator-go-to-page-label hide-on-mobile" for="goToPageSelect">Go to page</label>
        <c4g-page-dropdown
          [values]="getPagesAll()"
          [selected]="pageIndex"
          [disabled]="disabled"
          [displayWith]="displayGoToPage"
          (valueChange)="onGoToPageChange($event)">
        </c4g-page-dropdown>
      </div>

      <button
        class="c4g-paginator-button"
        [disabled]="disabled || pageIndex >= getMaxPage()"
        (click)="onPageChange({ pageIndex: pageIndex + 1, pageSize, length })"
        [attr.aria-label]="getNextPageLabel()"
      >
        <span class="c4g-paginator-icon">chevron_right</span>
      </button>

      <button
        class="c4g-paginator-button"
        [disabled]="disabled || pageIndex >= getMaxPage()"
        (click)="onPageChange({ pageIndex: getMaxPage(), pageSize, length })"
        *ngIf="showFirstLastButtons"
        [attr.aria-label]="getLastPageLabel()"
      >
        <span class="c4g-paginator-icon">last_page</span>
      </button>
    </div>

    <div class="c4g-paginator-page-size" *ngIf="!hidePageSize">
      <label class="c4g-paginator-page-size-label">{{ getItemsPerPageLabel() }}</label>
      <c4g-page-dropdown
        [values]="pageSizeOptions"
        [selected]="pageSize"
        [disabled]="disabled"
        [displayWith]="displayPageSize"
        (valueChange)="onPageSizeChange($event)">
      </c4g-page-dropdown>
    </div>
  </div>
</div>
